import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import URI from "urijs";
import { GlobalStore } from "../../stores/global";

export default function Main(props) {
  const [classNames, setClassNames] = useState("");
  const uri = new URI(useLocation().pathname).segment();
  const availableCountries = GlobalStore.useState(s => s.availableCountries);

  useEffect(() => {
    if (uri.indexOf("product-portal") > -1) setClassNames("portalPage");
    else if (availableCountries.indexOf(uri[0].toUpperCase()) > -1 && !uri[1]) setClassNames("home");
    else setClassNames("");
  }, [uri, availableCountries]);

  return <main className={classNames}>{props.children} </main>;
}
